<template>
  <hr-adaptive-menu
    ref="menuRef"
    v-slot="{ isMobile }"
    content="freeform"
    :model-value="modelValue"
    :title="$t('editor.modals.link.title')"
    :auto-close="false"
    anchor="top end"
    self="top start"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <hr-form
      class="link-form"
      :class="{ 'link-form--mobile': isMobile }"
      @submit.prevent="applyLink"
    >
      <div class="full-width row items-center no-wrap link-row">
        <hr-text-field
          v-model="link.href"
          autofocus
          hide-bottom-space
          :label="$t('editor.modals.link.inputLabel')"
          class="col"
        />
        <hr-confirm-btn
          v-if="!isMobile"
          :label="$t('common.buttonApply')"
          type="submit"
          class="q-ml-sm"
        />
      </div>
      <hr-setting-switch
        v-model="link.openInNewTab"
        :label="$t('editor.modals.link.openInNewTab')"
      />
      <hr-confirm-btn
        v-if="isMobile"
        :label="$t('common.buttonApply')"
        type="submit"
        class="full-width"
      />
    </hr-form>
  </hr-adaptive-menu>
</template>

<script>
import { Editor } from '@tiptap/vue-3';
import {
  HrAdaptiveMenu,
  HrConfirmBtn,
  HrForm,
  HrSettingSwitch,
  HrTextField,
} from 'src/design-system';

export default {
  name: 'TextEditorLink',

  components: {
    HrAdaptiveMenu,
    HrConfirmBtn,
    HrForm,
    HrSettingSwitch,
    HrTextField,
  },

  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    editor: {
      type: Editor,
      required: true,
    },
  },

  emits: ['update:modelValue'],

  data() {
    return {
      link: {
        href: '',
        openInNewTab: true,
      },
    };
  },

  watch: {
    modelValue(val) {
      if (val) {
        this.onMenuOpen();
      }
    },
  },

  methods: {
    onMenuOpen() {
      const attrs = this.editor.getAttributes('link');
      this.link.href = attrs.href ?? '';
      this.link.openInNewTab = attrs.target !== '_self';
    },

    applyLink() {
      this.editor
        .chain()
        .focus()
        .extendMarkRange('link')
        .setLink({
          href: this.link.href,
          target: this.link.openInNewTab ? '_blank' : '_self',
        })
        .run();

      this.$refs.menuRef.hide();
      this.$emit('update:modelValue', false);
    },
  },
};
</script>

<style lang="scss" scoped>
@media (min-width: $breakpoint-sm-min) {
  .link-row {
    min-width: 400px;
  }
}

.link-form--mobile {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
